import moment from 'moment';

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import * as DateTimeRegex from '../../../../constants';

@Component({
  selector: 'phoenix-datetime-input-dialog',
  templateUrl: './datetime-input-dialog.component.html',
  styleUrl: './datetime-input-dialog.component.scss',
  standalone: false,
})
export class DatetimeInputDialogComponent {
  dateValue!: string;
  isValid = false;

  constructor(
    public dialogRef: MatDialogRef<DatetimeInputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { initialValue: string }
  ) {
    this.dateValue = data.initialValue || '';
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  isValidISODate() {
    const date = moment(this.dateValue, true);
    this.isValid =
      date.isValid() &&
      (DateTimeRegex.SIMPLE_DATE_REGEX.test(this.dateValue) ||
        DateTimeRegex.ISO8601_DATE_REGEX.test(this.dateValue));
  }
}
